import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  /* -------------- 行人预约 -------------- */
  {
    path: '/personReservation',
    name: 'PersonReservation',
    component: Main,
    meta: {
      disabled: true,
      label: '行人预约',
    },
    children: [

      {
        name: 'PersonAdminReservationParent',
        path: 'admin',
        redirect: {name: 'PersonReservationGroupList'},
        meta: {
          label: '高级预约',
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'PersonNewGroupReservation',
            path: 'new',
            meta: {
              label: '新建高级预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Admin/new'),
          },
          {
            name: 'PersonAdminReservationDetails',
            path: ':plate/readonly',
            meta: {
              label: '预约详情',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Admin/details'),
          },
          {
            name: 'PersonEditAdminReservation',
            path: ':plate/edit',
            meta: {
              label: '编辑预约',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Admin/edit'),
          },
        ],
      },
      {
        name: 'PersonOrgReservation',
        path: 'organization',
        meta: {
          label: '单位预约',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Org/list'),
      },
      {
        name: 'PersonOrgReservationParent',
        path: 'organization',
        redirect: {name: 'PersonOrgReservation'},
        meta: {
          label: '单位预约',
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'PersonNewOrgReservation',
            path: 'new',
            meta: {
              label: '新建单位预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Org/new'),
          },
          {
            name: 'PersonReservationOrgDetails',
            path: 'PersonReservationOrgDetails/readonly',
            meta: {
              label: '预约详情',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Org/details'),
          },
          {
            name: 'PersonEditOrgReservation',
            path: ':plate/edit',
            meta: {
              label: '编辑预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Org/edit'),
          },
        ],
      },
      {
        name: 'PersonPersonalReservation',
        path: 'personal',
        meta: {
          label: '个人预约',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Personal/list'),
      },
      {
        name: 'PersonPersonalReservationParent',
        path: 'personal',
        redirect: {name: 'PersonPersonalReservation'},
        meta: {
          label: '个人预约',
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'PersonNewPersonalReservation',
            path: 'new',
            meta: {
              label: '新建个人预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Personal/new'),
          },
          {
            name: 'PersonPersonalReservationDetails',
            path: 'PersonPersonalReservationDetails/readonly',
            meta: {
              label: '预约详情',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Personal/details'),
          },
          {
            name: 'PersonEditPersonalReservation',
            path: ':plate/edit',
            meta: {
              label: '编辑预约',
              cacheKey: 'query.id'
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Personal/edit'),
          },
        ],
      },
      {
        name: 'PersonReservationGroupList',
        path: 'admin/group',
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Group/list'),
        meta: {
          label: '高级预约',
        },
      },
      {
        name: 'PersonReservationGroupParent',
        path: 'admin/group',
        redirect: {name: 'PersonReservationGroupList'},
        component: ParentView,
        props: true,
        meta: {
          label: '高级预约管理',
        },
        children: [
          {
            name: 'PersonNewReservationGroup',
            path: 'new',
            meta: {
              label: '新建高级预约',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Group/new'),
          },
          {
            name: 'PersonReservationGroupDetails',
            path: ':id/readonly',
            meta: {
              label: '预约分组',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Group/details'),
          },
          {
            name: 'PersonAddVehicle',
            path: 'addVehicle',
            meta: {
              label: '添加车辆',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Admin/new'),
          },
          {
            name: 'PersonEditReservationGroup',
            path: ':id/edit',
            meta: {
              label: '编辑预约分组',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Group/edit'),
          },
        ]
      },
      {
        name: 'PersonGroupReservationConfig',
        path: 'config/groupReservation',
        meta: {
          label: '高级预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Group/groupReservation'),
      },
      {
        name: 'PersonOrgReservationConfig',
        path: 'config/organization',
        meta: {
          label: '单位预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Org/orgReservation'),
      },
      {
        name: 'PersonGroupConfigList',
        path: 'config/GroupConfigList',
        meta: {
          label: '单位配置列表',
          disabled: true,
          hideInBread: true,
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'PersonNewGroupConfig',
            path: 'newGroupConfig',
            meta: {
              label: '新增预约单位配置',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Common/commonConfig_org'),
          },
        ],
      },
      {
        name: 'PersonConfigDetail',
        path: 'ConfigDetail',
        meta: {
          label: '配置详情',
        },
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Common/commonConfigBox'),
      },
      {
        name: 'PersonPersonalReservationConfig',
        path: 'config/personal',
        meta: {
          label: '个人预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Personal/personalReservation'),
      },
      {
        name: 'PersonPersonalConfigList',
        path: 'config/personalConfigList',
        redirect: {name: 'PersonPersonalReservationConfig'},
        meta: {
          label: '个人配置列表',
          disabled: true,
          hideInBread: true,
        },
        props: true,
        component: ParentView,
        children: [
          {
            name: 'PersonNewPersonalConfig',
            path: 'newPersonalConfig',
            meta: {
              label: '新建预约个人配置',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Common/commonConfig_personal'),
          },
          {
            name: 'PersonNewPersonalGroupConfig',
            path: 'newPersonalGroupConfig',
            meta: {
              label: '新建预约分组配置',
            },
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/Common/commonConfig_group'),
          },
        ],
      },

      {
        name: 'SelfServiceReservationConfig',
        path: 'config/selfService',
        meta: {
          label: '自助预约规则',
        },
        props: true,
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/PersonReservation/Config/SelfService'),
      },
    ],
  },

]
